<div
  class="avatar-container"
  [class.speakingBorder]="isLastActiveSpeaker"
  [class.no-video]="!isVideoOn"
>
  @if (!isVideoOn) {
    <div class="picture-container">
      <div class="avatar-wrapper">
        <app-basic-celo-avatar
          [userId]="this.userId"
          [size]="100"
          [badgeSize]="27"
          [name]="name"
          [isWorkspaceVerified]="isWorkspaceVerified"
          [isIdentityVerified]="isIdentityVerified"
          [isProfessionVerified]="isProfessionVerified"
        />
      </div>
    </div>
  }

  @if (!disableDetails) {
    <div class="details-container">
      @if (!disableName) {
        <div class="name">{{ name }}{{ isYou ? " (You)" : "" }}</div>
      }
      @if (isMuted) {
        <mat-icon class="mute-status">mic_off</mat-icon>
      }
    </div>
  }
</div>
